<template>
     <el-dialog
     title="新建产品"
     :visible.sync="dialogVisible"
     width="900px"
     top="25vh"
    :show-close="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="closeDialog"
    >
        <el-form ref="form" :model="form" :rules="proFormRules" label-width="100px" size="small">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="产品" prop="instockCode">
                      <el-select
                        v-model="form.instockCode"
                        clearable
                        filterable
                        placeholder="请选择"
                        style="width:100%;"
                        size="small"
                        @change="productChange"
                      >
                        <el-option
                          v-for="item in processNameList"
                          :key="item.productCode"
                          :label="item.productName"
                          :value="item.productCode"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="入库数量" prop="instockNum">
                      <el-input-number size="small" v-model="form.instockNum" @change="handleChange" controls-position="right" :min="1" :max="9007199254740991" label="请填写" style="width:100%;"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="flag">
                    <el-form-item label="产品数据">
                      <span>{{'库存单位：' + product['unit']}}</span> <br />
                      <span>{{'当前库存数量：' + (product['stockNum'] == undefined?0:product['stockNum'])}}</span>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="12">
                    <el-form-item label="类别" style="position: relative;">
                      <div class="choose-title" @click="showMenu" :class="{'common-people':form.type == '半成品','important-people':form.type == '成品'}">{{form.type}}</div>
                      <el-select  size="small" v-model="form.type" clearable ref="selectChoose" filterable :placeholder="!form.type ? form.type:''" class="full-width" popper-class="custumer-type" @clear="clearCustomer">
                        <el-option
                          v-for="item in customerOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                          <div class="self-select-box" :class="{'common-people':item.label == '半成品','important-people':item.label == '成品'}">{{item.label}}</div>
                        </el-option>
                      </el-select>
                    </el-form-item>
                </el-col> -->
                <!-- <el-col :span="12">
                    <el-form-item label="客户物料编号" prop="customName">
                        <el-input size="small" v-model="form.customName" placeholder="输入客户物料编号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="订单单号" prop="customName">
                        <el-input size="small" v-model="form.customName" placeholder="请填写订单单号"></el-input>
                    </el-form-item>
                </el-col> -->


            </el-row>
        </el-form>
       <div class="panel-bottom">
            <el-button size="small" type="default"  @click="handleCancel">取消</el-button>
            <el-button size="small" type="primary"  @click="handleSave">保存</el-button>
        </div>

    </el-dialog>
</template>
<script>
import { productGetAll} from '@/api/basicData';

export default {
    name:'CreateProduct',
    props:{
        diaVisible:Boolean,
    },
    data(){
        return{
            dialogVisible: false,
            form:{
              instockCode:'',
              instockNum:'',
            },
            product:{},
            proFormRules:{
              processName:[{required:true,message:'请选择产品',trigger:['blur','change']}],
              instockNum:[{required:true,message:'请输入入库数量',trigger:['blur','change']}],
            },
            processNameList: [],
            customerOptions: [{
              value: '成品',
              label: '成品'
            }, {
              value: '半成品',
              label: '半成品'
            }],
            user:JSON.parse(window.localStorage.getItem('userdata')),
            flag:false,
        }
    },
    created(){
      this.dialogVisible = this.diaVisible;
      this.getList();
    },
    methods:{
      getList(){
        productGetAll(this.user['factoryId']).then(res=>{
          if(res['code'] == 200){
            this.processNameList =  res['data'];
          }
        })
      },
      handleChange(){},
      handleSave(){
        this.$refs["form"].validate((valid) => {
          if(valid){
            this.dialogVisible = false;
            this.$emit('save',{product:this.product,form:this.form});
          }
        })
      },
      handleCancel(){
          this.dialogVisible = false;
      },
      closeDialog(){
          setTimeout(() => {
              this.dialogVisible = false;
              this.$emit('close')
          }, 100);
      },
      clearCustomer(){
        this.form.type = ''
      },
      showMenu(){
        this.$nextTick(_ => { this.$refs.selectChoose.toggleMenu(); });
      },
      productChange(val){
        if(val){
          let list = this.processNameList.filter(item=>item['productCode'] == val);
          if(list.length > 0){
            this.product = list[0];
            this.flag = true;
          }else{
            this.product ={};
            this.flag = false;
          }
        }else{
          this.product ={};
          this.flag = false;
        }
      }
    }

}
</script>
<style scoped>
.panel{
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0px 50px;
}

.panel-bottom{
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
}
.panel-bottom el-button{
    margin: 10px 0 0 10px;
}
.self-select-box{
  display: inline-block;
  /* margin: 4px 0; */
  padding: 0 4px;
  width: 80px;
  text-align: center;
  border-radius: 5px;
}
.custumer-type .default-people,
.default-people{
  color: #606266;
  background-color:#F4F4F5;
}
.custumer-type .el-select-dropdown__item{
  height: 28px;
  line-height: 28px;
  margin: 5px 0;
}
.custumer-type .el-select-dropdown__item.selected{
  color: #606266;
  font-weight: normal;
  background-color: #ECF5FF;
}
.custumer-type .common-people,
.common-people{
  color: rgb(61, 210, 126);
  background-color: rgb(233, 247, 239);
}
.custumer-type .important-people,
.important-people{
  color: rgb(255, 89, 80);
  background-color: rgb(249, 234, 233);
}
.choose-title{
    display: inline-block;
    width: 80px;
    position: absolute;
    z-index: 1000;
    left: 15px;
    top: 6px;
    height: 24px;
    line-height: 24px;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/views/stockManagement/warehousingOrder/CreateProduct.vue